<template>
  <vs-popup :title="$t('Users')" :active.sync="popupActive">
    <div>
      <div class="vx-row mb-2">
        <div class="vx-col lg:w-1/3 w-full">
          <label class="vs-select--label">{{ $t("UserName") }}</label>
          <vs-input
            name="user"
            v-model="gridSearchData.UserName"
            @keyup.enter="searchUserName()"
          />
        </div>
        <div class="vx-col lg:w-1/6 w-full">
          <vs-button
            class="mt-6 p-2"
            color="success"
            type="gradient"
            icon-pack="feather"
            icon="icon-search"
            @click.prevent="searchUserName()"
          ></vs-button>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          <data-grid
            ref="grid"
            stripe
            :data-source="gridDataSource"
            :search-data="gridSearchData"
            :columns="[
              { title: $t('UserName'), sort: 'UserName' },
              { title: $t('UserId'), sort: 'UserId' },
              { title: $t('Action'), sort: 'Action' }
            ]"
          >
            <template slot-scope="{ row }">
              <td style="width: 40%">
                {{ row.userName }}
              </td>
              <td style="width: 20%">
                {{ row.id }}
              </td>

              <td style="width: 20%">
                <vs-button
                  radius
                  color="success"
                  size="small"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-plus"
                  @click.prevent="addUserToRole(row)"
                  class="ml-4 d-inline"
                ></vs-button>
              </td>
            </template>
          </data-grid>
        </div>
      </div>
    </div>
  </vs-popup>
</template>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import { mapActions } from "vuex";
export default {
  name: "",
  props: {
    showUserList: { default: false },
    roleCurrent: {}
  },
  data() {
    return {
      gridDataSource: {},
      gridSearchData: {
        UserName: ""
      },
      modelForAssign: {}
    };
  },
  computed: {
    popupActive: {
      get: function() {
        return this.showUserList;
      },
      set: function() {
        this.$emit("finish");
      }
    }
  },
  components: {
    DataGrid
  },
  methods: {
    ...mapActions({
      AssignUser: "user/updateUserRoles",
      getListRolesUser: "user/fetchByRoleId"
    }),
    searchUserName() {
      this.$refs.grid.renderGrid();
    },
    addUserToRole(role) {
      this.modelForAssign.userId = role.id;
      this.AssignUser(this.modelForAssign).then(() => {});
    }
  },
  watch: {
    showUserList() {
      if (this.showUserList) {
        this.gridDataSource = {
          type: "app",
          service: "IdentityAccess/api/UsersQuery"
        };
        setTimeout(() => {
          this.$refs.grid.renderGrid();
        }, 200);
      }
    }
  }
};
</script>
